function Page404() {
  return (
    <div className="flex flex-col items-center justify-center h-dvh p-4">
      <div className="p-4 border-1 border-black bg-white text-center max-w-md">
        <h1 className="text-2xl mb-4">404: Not Found</h1>
        <p>The page you are looking for does not exist.</p>
      </div>
    </div>
  );
}

export default Page404;
